<mat-form-field appearance="outline" class="{{ className }}">
    <mat-label>{{ label }}</mat-label>
    <mat-chip-list #chipList aria-label="Item selection">
        <mat-chip *ngFor="let item of selectedItems"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="remove(item)"
                  (click)="chipClick(item)"
                  class="{{ chipCssClass }}"
                  [disabled]="disabled">
            <app-image srcPath="{{ item.AvatarBlobPath }}" isApiImage="true" className="app-image-extra-small-chip app-image-circle"></app-image>
            {{ (item.IsDefault ? "DEFAULT: " : "") + item.Name }}
            <mat-icon matChipEdit *ngIf="item.IsEditable" matTooltip="Edit {{ item.Name }}" class="mat-chip-edit-icon">edit</mat-icon>
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input #itemInput [formControl]="itemControl" 
                          [matAutocomplete]="auto" 
                          [matChipInputFor]="chipList" 
                          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" 
                          [matChipInputAddOnBlur]="addOnBlur" 
                          (matChipInputTokenEnd)="add($event)"
                          [disabled]="disabled" 
                          style="max-width: 48px;" />
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let item of filteredItems | async" [value]="item">
            <app-image srcPath="{{ item.AvatarBlobPath }}" isApiImage="true" className="app-image-extra-small app-image-circle" style="position: relative;top: 10px;margin-right: 12px;"></app-image>
            {{ (item.IsDefault ? "DEFAULT: " : "") + item.Name }}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
